export const requestedPathKey = 'requestedPathOnAutoLogout';

// Java's maximum integer value
export const API_MAX_LIMIT = 2147483647;

const authBaseUri = 'api/identity/auth';

export const authEndpoints = {
  authenticate: `${authBaseUri}/authenticate`,
  codeExchange: `${authBaseUri}/code-exchange`,
  logout: `${authBaseUri}/logout`,
  mfaExchange: `${authBaseUri}/mfa-exchange`,
  mfaResend: `${authBaseUri}/mfa-resend`,
  passwordResetRequest: `${authBaseUri}/password-reset/request`,
  passwordResetValidate: `${authBaseUri}/password-reset/validate`,
  passwordResetComplete: `${authBaseUri}/password-reset/complete`,
  refreshToken: `${authBaseUri}/refresh`,
};

const oauthBaseUri = 'api/auth/oauth';

export const oauthEndpoints = {
  clientRegistration: `${oauthBaseUri}/clients/register`,
};

const userRegistrationBaseUri = 'api/identity/internal/users/registration';

export const userEndpoints = {
  registrationIntent: `${userRegistrationBaseUri}/intent`,
  registration: userRegistrationBaseUri,
  registrationConfirm: `${userRegistrationBaseUri}/confirm`,
  registrationResend: `${userRegistrationBaseUri}/resend-code`,
};
